import { isServiceOpenInCatalog } from "@/lib/is-service-open"
import { ApiData } from "@/types"

/**
 * Whether the DELIVERY channel is closed right now, derived from a catalog snapshot.
 *
 * Kept for ApiCache / holidayHoursAtom (home storefront without `?table=` is
 * the DELIVERY menu). Order submit and multi-channel UI must use
 * `isServiceOpenInCatalog(data, serviceType)` for the channel actually being
 * ordered (DELIVERY | TAKEOUT | INDOOR).
 *
 * Closed when the merchant toggled the store off, or when the DELIVERY service
 * is on a holiday window, outside weekly hours, missing, or not AVAILABLE.
 */
export function isMerchantClosed(data: ApiData): boolean {
  return !isServiceOpenInCatalog(data, "DELIVERY")
}
